import { render, staticRenderFns } from "./GasData.vue?vue&type=template&id=cd9bc182&scoped=true"
import script from "./GasData.vue?vue&type=script&lang=js"
export * from "./GasData.vue?vue&type=script&lang=js"
import style0 from "./GasData.vue?vue&type=style&index=0&id=cd9bc182&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd9bc182",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd9bc182')) {
      api.createRecord('cd9bc182', component.options)
    } else {
      api.reload('cd9bc182', component.options)
    }
    module.hot.accept("./GasData.vue?vue&type=template&id=cd9bc182&scoped=true", function () {
      api.rerender('cd9bc182', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Basics/BasicsEnergyData/GasData/GasData.vue"
export default component.exports